// Canonical listing-status vocabulary. The same strings appear in the results
// filters (src/content/results/filters.js), the advanced-search status options,
// and the search model's status handling (src/lib/models/search.js) — when a
// status is added there, add it here so market-summary copy recognizes it.

export const LISTING_STATUSES = ['Active', 'Pending', 'Coming Soon', 'Sold'];

// Statuses that describe current on-market inventory (everything but Sold).
export const CURRENT_LISTING_STATUSES = ['Active', 'Pending', 'Coming Soon'];
